import { Button, Table } from "antd";
import styled from "styled-components";

export const TopContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 515px) {
    display: block;
  }
`;

export const StyledButton = styled(Button)`
  color: rgba(49, 65, 88, 1);
  border: none;
  background-color: transparent;

  &:hover {
    color: rgba(49, 65, 88, 1);
    background-color: transparent;
    transform: scale(1.05);
  }
`;
export const CollaboratorsTable = styled(Table)`
  margin-top: 20px;

  thead .ant-table-cell {
    color: #314158 !important;
    font-family: "Inter", sans-serif !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 100% !important;
    letter-spacing: 0% !important;
  }
  .ant-table {
    overflow: hidden;
    border: 1px solid rgba(226, 232, 240, 1);
    border-radius: 10px;
  }
  .ant-table-tbody > tr:last-child > td {
    border-bottom: none !important;
  }

  tbody .ant-table-cell {
    color: #314158 !important;
    font-family: "Inter", sans-serif !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 100% !important;
    letter-spacing: 0% !important;
  }
  .ant-table-thead > tr > th {
    background-color: white !important;
    font-family: "Inter", sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    color: rgba(49, 65, 88, 1);
  }

  .ant-table-tbody > tr:nth-child(odd) > td,
  .ant-table-tbody > tr:nth-child(odd) > td.ant-table-column-sort {
    background-color: rgba(226, 226, 247, 0.2);
  }

  .ant-table-tbody > tr:nth-child(even) > td,
  .ant-table-tbody > tr:nth-child(even) > td.ant-table-column-sort {
    background-color: white;
  }

  .ant-table-tbody > tr:hover > td,
  .ant-table-tbody > tr:hover > td.ant-table-column-sort,
  .ant-table-tbody > tr.ant-table-row:hover > td,
  .ant-table-tbody > tr.ant-table-row:hover > td.ant-table-column-sort {
    background-color: #fafafa;
  }

  @media (max-width: 1200px) {
    .ant-table-thead > tr > th {
      font-size: 14px;
    }

    .ant-table-tbody > tr > td {
      font-size: 14px;
    }
  }

  @media (max-width: 768px) {
    .ant-table-thead > tr > th {
      font-size: 12px;
    }

    .ant-table-tbody > tr > td {
      font-size: 12px;
    }
  }
`;

export const DeleteCollaboratorWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  align-items: center;
`;
export const DeleteCollaboratorButton = styled(Button)`
  width: 42px;
  height: 32px;
  margin-left: 10px;
  padding-top: 8px;
  padding-right: 12px;
  padding-bottom: 8px;
  padding-left: 12px;
  border-radius: 10px;
  border: none;
  align-items: center;
  display: flex;
  justify-content: center;
`;
